import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/donor/panel`;


async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

async function get(path, fallbackError) {
  const res = await authFetch(`${BASE}${path}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || fallbackError);
  }
  return payload;
}

export const getDonorDonationHistory = () =>
  get("/donation-history", "Failed to fetch donation history");

export const getDonorDonationTracking = () =>
  get("/donation-tracking", "Failed to fetch donation tracking");
